import React from 'react';
import Translation from '../translation/translation';

function FSFMotoLightBoxContent() {
    return (
        <div className="fsf-moto-light-box__content fsf-moto-light-box-content">
            <div className="progress-list">
                <p className="progress-list__item progress-list-item progress-list-item--active">
                    <strong className="progress-list-item__headline">
                        <Translation translationKey="fsf-moto-light-box-progress-first-headline" />
                    </strong>
                    <Translation translationKey="fsf-moto-light-box-progress-first-text" />
                </p>
                <p className="progress-list__item progress-list-item">
                    <strong className="progress-list-item__headline">
                        <Translation translationKey="fsf-moto-light-box-progress-second-headline" />
                    </strong>
                    <Translation translationKey="fsf-moto-light-box-progress-second-text" />
                </p>
                <p className="progress-list__item progress-list-item">
                    <strong className="progress-list-item__headline">
                        <Translation translationKey="fsf-moto-light-box-progress-third-headline" />
                    </strong>
                    <Translation translationKey="fsf-moto-light-box-progress-third-text" />
                </p>
            </div>

            <div className="fsf-moto-light-box-content__call-us">
                <a
                    className="fsf-moto-light-box-content__cta"
                    href="http://support.tyroola.com.au/en/support/tickets/new"
                    target="_blank"
                >
                    <Translation translationKey="fsf-moto-light-box-cta-text" />
                </a>
            </div>
        </div>
    );
}

export { FSFMotoLightBoxContent };
